



















































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import api from '@/common/api';
import { Processor, ProcessorType } from '@/common/types/processors.types';
import LoadingModal from '@/common/components/LoadingModal.vue';
import ProcessorEdit from './ProcessorsEdit.vue';

export default Vue.extend({
  data() {
    return {
      processorToEdit: {} as object,
      loading: true,
      hideFooter: true as boolean,
      merchantProcessors: [],
      processorToSettle: null as Processor | null,
      showSettlementModal: false as boolean,
      loadingText: '' as string,
      isSubmitting: false as boolean,
      headers: [
        {
          text: 'id',
          value: 'id',
          sortable: false,
          align: ' d-none',
        },
        {
          text: 'Name',
          value: 'name',
          sortable: false,
          class: 'entity-table-header subtitle-2 font-weight-black',
        },
        {
          text: 'Type',
          value: 'supports',
          sortable: false,
          class: 'entity-table-header subtitle-2 font-weight-black',
        },
        {
          text: 'Processor',
          value: 'key',
          sortable: false,
          class: 'entity-table-header subtitle-2 font-weight-black',
        },
        {
          text: 'Settlement Time',
          value: 'settlementTimeUtc',
          sortable: false,
          class: 'entity-table-header subtitle-2 font-weight-black',
          align: 'center',
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
          align: 'center',
          class: 'entity-table-header subtitle-2 font-weight-black',
        },
      ],
    };
  },
  computed: {
    ...mapGetters(['processors', 'context']),
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      this.$store
        .dispatch('loadMerchantProcessors', this.context)
        .then(() => {
          this.merchantProcessors = this.processors.filter(
            (item:Processor) => item.key !== ProcessorType.CASH,
          );
        })
        .catch(() => {
          this.merchantProcessors = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    editProcessor(processor: Processor) {
      this.processorToEdit = processor;
      (this.$refs.editModal as any).show();
    },
    formatAMPM(time:any) {
      const tArray = time.split(':');
      let hours:number = tArray[0];
      const minutes:number = tArray[1];
      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours %= 12;
      hours = hours || 12; // the hour '0' should be '12'
      return `${hours}:${minutes} ${ampm}`;
    },
    promptForSettle(item: any) {
      this.showSettlementModal = true;
      this.processorToSettle = item;
    },
    settleProcessor() {
      this.submitActions(true);
      this.showSettlementModal = false;
      api
        .post('/settle-batch/', {
          processor: this.processorToSettle?.id,
        })
        .then(this.showSuccess)
        .catch(() => {
          this.$toasted.error('Failed to settle batch for this transaction');
        })
        .finally(() => {
          this.submitActions(false);
        });
    },
    showSuccess() {
      this.$toasted.success('Open batch for this processor settled successfully');
    },
    submitActions(isSubmitting: boolean, loadingText: string = 'Settling...') {
      this.isSubmitting = isSubmitting;
      this.loadingText = loadingText;
    },
  },
  components: {
    ProcessorEdit,
    LoadingModal,
  },
});

